const API_BASE_URL = 'https://payment.appkalea.com/v1'
let CONTAINER_CAROUSEL
let INSTALLMENTS = []
let CAROUSEL = {}

const customPrevButton = document.createElement('button')
const customNextButton = document.createElement('button')
buttonSettings( customPrevButton, customNextButton )

document.addEventListener('DOMContentLoaded', () => {
    retrieveAndCreateInstallments()
})

document.addEventListener('variant:changed', (evt) => {
  	const { variant } = evt.detail
    VARIANT_INFO.price = variant.price / 100
    renderNewInstallments()
})

const retrieveAndCreateInstallments = async () => {
    console.log(VARIANT_INFO) // This comes from product-template.liquid
	
    const containerInstallments = document.querySelector('.credit-card__tags')
    CONTAINER_CAROUSEL = containerInstallments
    
    CAROUSEL = new Flickity(CONTAINER_CAROUSEL, {
        cellAlign: 'center',
        pageDots: false,
      	autoPlay: true,
      	percentPosition: true,
      	wrapAround: true,
        prevNextButtons: false
    })

    CONTAINER_CAROUSEL.prepend(customNextButton)
    CONTAINER_CAROUSEL.prepend(customPrevButton)

    const request = await fetch(`${API_BASE_URL}/installment`, {
        method: 'GET',
        headers: { 'Authorization': 'Basic a2FsZWE6QWthaGF0YTA1' }
    })
    const response = await request.json()
    console.log(response)
    INSTALLMENTS = response.installments
    
    renderNewInstallments(true)
}

const renderNewInstallments = ( isFirst = false ) => {
  	const initialInstallmentContainer = document.querySelector('.installment--initial')
    const cardsForClone = document.querySelector('.credit-card__cards')
    const actualIndex = CAROUSEL.selectedIndex
    
    INSTALLMENTS.forEach( (installment, i) => {
    	i === INSTALLMENTS.length - 1 && initialInstallmentContainer && CAROUSEL.remove(initialInstallmentContainer)
        const installmentVal = installment.installment
        const fee = Number(installment.installment_fee)
       	const newValWithFee = Number((VARIANT_INFO.price + VARIANT_INFO.price*fee).toFixed(2))
        const newValText = `${new Intl.NumberFormat("de-DE", 
            {style: "currency", currency: "GTQ"}
        ).format(fee ? newValWithFee : VARIANT_INFO.price).split('GTQ')[1].replace(/\s/g, '')} Q`
        // const valPerInstallment = (newValWithFee / installmentVal).toFixed(2)
        const valPerInstallment = new Intl.NumberFormat("ar-AR", 
            {style: "currency", currency: "GTQ"}
        ).format((newValWithFee / installmentVal).toFixed(2)).split('GTQ')[1].replace(/\s/g, '')
               
        if ( isFirst ) {
            const newBox = document.createElement('div')
            const newText = document.createElement('div')
            newBox.classList.add('installment--item-container')
            newBox.dataset.installment = installmentVal
            newText.classList.add('credit-card__message')
            newText.textContent = `${installment.name} de Q${valPerInstallment}`
            newBox.appendChild(newText)
            newBox.appendChild(cardsForClone.cloneNode(true))

            CAROUSEL.append(newBox)
        } else {
            const boxInstallment = document.querySelector(`.installment--item-container[data-installment="${installmentVal}"]`)          
            if ( boxInstallment ) boxInstallment.children[0].textContent = `${installment.name} de Q${valPerInstallment}`
        }
    })
}

function prevNextButtonsHandler( evt ) {
    evt.preventDefault()
    evt.stopPropagation()
    const target = evt.target.tagName.toLowerCase() === 'button' ? evt.target : evt.target.parentElement
    const buttonType = target.dataset.move
    if ( buttonType === 'next') CAROUSEL.next()
    else CAROUSEL.previous()
}

function buttonSettings( button1, button2 ) {
    button1.classList.add('customPrevPaginater')
    button2.classList.add('customNextPaginater')
    button1.dataset.move = 'prev'
    button2.dataset.move = 'next'
    button1.innerHTML = '<span><</span>'
    button2.innerHTML = '<span>></span>'

    button1.type = 'button'
    button2.type = 'button'

    button1.addEventListener('click', prevNextButtonsHandler)
    button2.addEventListener('click', prevNextButtonsHandler)
}